var swiper = new Swiper(".wh-confidence-strip-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    breakpoints: {
        0: {
            slidesPerView: 'auto',
        },
        767: {
            slidesPerView: 'auto',
        },
        768: {
            slidesPerView: 2,
        },
        1023: {
            slidesPerView: 2,
        },
        1024: {
            slidesPerView: 3,
        },
        1199: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 4,
        },
    },
});